export function numberToLetter(num: number): string {
  return String.fromCharCode((num || 10) + 64);
}
